<template>
  <div>
    <BigTitle :bigtitle="bigtitle"></BigTitle>
    <!-- 考核指标 -->
    <Indicators :userList="assessTargetList"></Indicators>
  </div>
</template>
<script>
import BigTitle from '@/components/bigTitle';
import Indicators from '@/components/common/indicators';
import { siteLeft } from '@/api/singleSite/left';
import { dataInterface } from '@/api/dataInterfaceApi';


export default {
  data () {
    return {
      options: {},
      bigtitle:{
        CHN:'考核指标',
        ENG:'Evaluation index'
      },
      assessTargetList:[{
        counts:'',
        text:"运营业务收入（万）",
        percent:""
      },{
        counts:'',
        text:"运营成本（万）",
        percent:""
      },{
        counts:'',
        text:"充电电量（度）",
        percent:""
      }]
    };
  },
  components: {
    BigTitle,
    Indicators
  },
  props: {

  },
  watch: {
    
  },
  mounted () {
  },
  methods: {
    getData(data){
      this.selectStationAssessTarget(data)
    },
    //TiDB-站点-考核指标
    selectStationAssessTarget(data={}){
      let _this = this;
      let params = {
          "enCode":"TiDB-zhandian-kaohezhibiaoshouru",
          "@station_id":data.stationId
        }
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if(!res) return;
          res = res[0];
          _this.assessTargetList = [{
            counts:res.oper_income,
            text:"本月运营业务收入（元）",
            percent:res.rcvAmountCompletionRate
          },{
            counts:res.charge_cost,
            text:"本月运营成本（元）",
            percent:res.stationCostCompletionRate
          },{
            counts:res.totalelect,
            text:"本月充电电量（度）",
            percent:res.salesElectCompletionRate
          }];
        })
        .catch((err) => {
          console.log(err);
        });
    },
  }
}
</script>
<style lang="scss" scoped>

</style>